import * as React from 'react'
import clx from 'classnames'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import {
  FaIcon,
  faArrowRight,
  faArrowRightFromBracketSolid,
  faArrowsRotate,
  faRefreshSolid,
  faBuildingSolid,
  faBuildingsSolid,
  faCalculator,
  faSlidersSolid,
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faChevronsLeftSolid,
  faChevronsRightSolid,
  faCircleCheck,
  faCircleDashedRegular,
  faCircleInfo,
  faCircleXmark,
  faEarthEurope,
  faEye,
  faGearSolid,
  faTableColumnsSolid,
  faUser,
  faFloppyDisk,
  faLocationDotSlashSolid,
  faMagnifyingGlassSolid,
  faPaperPlaneSolid,
  faPenToSquare,
  faPlus,
  faPrint,
  faStarRegular,
  faStarSolid,
  faQuestionCircleSolid,
  faTrash,
  faTriangleExclamationSolid,
  faUsers,
  faXmark,
} from '@/lib/fa'

/**
 * Ikony panelu admina.
 *
 * Panel rysował ikony jako `background-image` na `<i class="et0-icon nazwa">`; tutaj ta
 * sama nazwa mapuje się na ikonę z Font Awesome, tak jak w nowym froncie. Nazwa zostaje
 * na elemencie, bo arkusze pozycjonują ikony po niej (`.search-box i.search`,
 * `i.et0-icon.connected { float: left }`), a część nazw jest wyliczana w locie
 * (`getConnectionIcon`).
 */
const ICONS: Record<string, IconProp> = {
  search: faMagnifyingGlassSolid,
  edit: faPenToSquare,
  delete: faTrash,
  add: faPlus,
  close: faXmark,
  'cancel-2': faXmark,
  print: faPrint,
  'print-white': faPrint,
  'close-white': faXmark,
  'add-white': faPlus,
  save: faFloppyDisk,
  'save-white': faFloppyDisk,
  child: faEye,
  people: faUsers,
  company: faBuildingSolid,
  dashboard: faTableColumnsSolid,
  profil: faUser,
  settings: faGearSolid,
  help: faCircleInfo,
  language: faEarthEurope,
  logout: faArrowRightFromBracketSolid,
  'company-group': faBuildingsSolid,
  accounting: faCalculator,
  'arrow-right': faArrowRight,
  menu: faSlidersSolid,
  'double-arrow-left': faChevronsLeftSolid,
  'double-arrow-right': faChevronsRightSolid,
  check: faCircleCheck,
  send: faPaperPlaneSolid,
  'send-invalid': faPaperPlaneSolid,
  unlock: faEye,
  'unlock-invalid': faEye,
  lock: faEye,
  connected: faCircleCheck,
  'not-connected': faCircleXmark,
  processing: faArrowsRotate,
  refresh: faRefreshSolid,
  creating: faCircleDashedRegular,
  unknown: faQuestionCircleSolid,
  'arrow-down': faChevronDown,
  'arrow-left': faChevronLeft,
  'arrow-up': faChevronUp,
  toast_success: faCircleCheck,
  toast_warning: faTriangleExclamationSolid,
  'location-off': faLocationDotSlashSolid,
  default: faStarSolid,
  'not-default': faStarRegular,
}

type AdminIconProps = React.HTMLAttributes<HTMLElement> & {
  /** Nazwa z dawnej klasy `et0-icon <nazwa>`. */
  name: string
}

export const AdminIcon = React.forwardRef<HTMLElement, AdminIconProps>(
  ({ name, className, ...rest }, ref) => (
    <i ref={ref} className={clx('et0-fa', name, className)} {...rest}>
      <FaIcon icon={ICONS[name] ?? faQuestionCircleSolid} />
    </i>
  ),
)

AdminIcon.displayName = 'AdminIcon'
